export default "__VITE_ASSET__502abd8e__"